import React, { ComponentPropsWithoutRef, forwardRef } from "react"
import { InputVariantProps, inputVariants } from "../../styles"
import { classNames } from "../../utils"

export type TextAreaProps = ComponentPropsWithoutRef<"textarea"> &
  InputVariantProps

/**
 * Displays a form textarea.
 */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  function TextArea({ className, disabled, error, variant, ...props }, ref) {
    return (
      <textarea
        className={classNames(
          inputVariants({ variant, disabled, error }),
          "h-auto w-full resize-y rounded-lg p-3",
          "bg-transparent outline-hidden",
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
